__turbopack_context__.v({
  "select": "wckH2W_select",
  "selectWrapper": "wckH2W_selectWrapper",
});
